<template>
  <div>
    <vs-textarea v-model="value" />
    <vs-input v-model="options.quantity" />
    <h6>REGNA - QR</h6>
    <vs-checkbox v-model="options.watermark"/>
    <img :src="imageSrc">
    <br>
    <vs-button @click="teste()">CLIQUE</vs-button>
  </div>
</template>

<script>
import axios from 'axios'
import { baseApiUrl } from "@/global"

export default {
  data() {
    return {
      options: { margin: 2, watermark: true, quantity: 5, width: 200},
      imageSrc: '',
      value: `N° Ordem de Compra: 27
Data: 21/10/2020
Técnico: Elto`
    }
  },
  methods: {
    async teste() {
      const response = await axios.post(`${baseApiUrl}/qrcode/generate`, { text: this.value, options: this.options })
      this.imageSrc = response.data
    }
  },
  created(){
    this.teste()
  }
}

</script>

<style>

</style>
